<script lang="ts">
    import {authFetch} from "../Auth";
    import {overlay} from "../Store";
    import type {ContactData, UserData, UserNameData} from "../Types";
    import {getRouteById} from "../Nav";
    import Sort from "../Component/Sort.svelte";
    import throttle from "@jcoreio/async-throttle";
    import {DateTime} from "luxon";
    import {MessageStatus, strToLocaleDateTime,UserStatus,UserType} from "../Utils";
    import AuthImage from "../Component/AuthImage.svelte";
    import AddContactAsUserButton from "../Component/AddContactAsUserButton.svelte";

    export const params = {}
    let filter = {
        offset: 0,
        limit: 100,
        phrase: "",
        order: "DESC",
        orderBy: "id"
    }
    let contacts: ContactData[] = []
    let users: {
        [key: string]: UserData
    } = {}
    let count: number = 0
    let listPromise: Promise<any>

    let onInput = throttle(()=>{
        update()
    }, 1000)

    async function loadList() {
        let response = await authFetch('contacts/search', {
            method: 'POST',
            body: JSON.stringify(filter),
        })
        if (response.ok) {
            let data = await response.json()
            contacts = data?.contacts ?? []
            count = data.count
            users = data?.users ?? {}
        } else {
            alert(response.statusText)
        }
    }

    function onSort(ev: Event){
        if(ev.detail.order === null){
            filter.order = "DESC"
            filter.orderBy = "id"
        } else {
            filter.order = ev.detail.order
            filter.orderBy = ev.detail.orderBy
        }
        update()
    }

    function update(){
        listPromise = loadList()
    }
    update()
</script>
<style>
    .ua {
        background: rgba(255, 0, 0, 0.75);
        color: white;
    }
</style>
<table class="table table-bordered table-sm">
    <thead class="position-sticky bg-white shadow" style="z-index: 1030; top: 56px;">
        <tr style="border: 0px;">
            <th colspan="100">
                <div class="input-group">
                    <input class="form-control" type="search" placeholder="ФІО / телефон / telegram_id"
                        bind:value={filter.phrase} on:keyup={onInput} on:change={onInput}>
                    <button class="btn btn-info"
                        class:disabled={filter.offset===0}
                        on:click={()=>{filter.offset-=filter.limit;update()}}>
                        <i class="bi bi-chevron-left"></i>
                    </button>
                    <input class="form-control flex-grow-0" type="number" style="width: 5em;"
                           min="1"
                           max={Math.floor(count / filter.limit)+1}
                           step="1"
                           value={(filter.offset / filter.limit)+1}
                           on:change={(ev)=>{filter.offset=(ev.target.value - 1) * filter.limit; update()}}
                    >
                    <button class="btn btn-info disabled">
                        / {Math.floor(count / filter.limit)+1}
                    </button>
                    <button class="btn btn-info"
                            class:disabled={contacts.length < filter.limit}
                            on:click={()=>{filter.offset+=filter.limit;update()}}>
                        <i class="bi bi-chevron-right"></i>
                    </button>
                </div>
            </th>
        </tr>
        <tr style="border: 0px; font-size: 14px;">
            <th rowspan="2" style="min-width: 70px">ID <Sort orderBy="id" state={filter} orders={["ASC","DESC"]} on:sort={onSort}></Sort></th>
            <th rowspan="2" style="min-width: 120px">Ім'я</th>
            <th rowspan="2">Телефон</th>
            <th rowspan="2">Telegram ID</th>
            <th colspan="10">Контакт</th>
            <th rowspan="10" style="min-width: 100px">Створений</th>
            <th></th>
        </tr>
        <tr style="font-size: 14px;">
            <th style="min-width: 75px">Фото</th>
            <th style="min-width: 75px">ПІБ</th>
            <th>Telegram ID</th>
            <th>Телефон</th>
            <th >Username</th>
            <th>Контакт</th>
            <th>Взаємний контакт</th>
            <th>Тип</th>
            <th>Статус</th>
            <th>Був онлайн</th>
        </tr>
    </thead>
    <tbody>
    {#await listPromise}
        <tr>
            <td colspan="1000" class="text-center">
                <div class="spinner-grow"></div>
            </td>
        </tr>
    {:then _}
        {#if contacts.length > 0}
            {#each contacts as contact}
                <tr>
                    <td rowspan="1">{contact.id}</td>
                    {#if contact.telegram_user_id in users}
                        <td rowspan="1">{users[contact.telegram_user_id].names.length > 0 ?
                            users[contact.telegram_user_id].names.map((item) => item.name).join(', ') :
                            '-'
                        }</td>
                        <td rowspan="1">{users[contact.telegram_user_id].phone}</td>
                    {:else }
                        <td rowspan="1">-</td>
                        <td rowspan="1">-</td>
                    {/if}
                    <td rowspan="1">{contact.telegram_user_id ?? ''}</td>
                    <td class="text-center" style="width: 100px">
                        {#if contact.small_path && contact.small_path.length > 0}
                            <AuthImage width="100" imageClass="rounded-circle" src="/user/{contact.telegram_user_id}/contact/{contact.id}/avatar"/>
                        {/if}
                        {#if contact.attachments && contact.attachments.length > 0}
                            {#if contact.attachments[0]?.telegram_attachment_id?.length > 0 || contact.attachments[0]?.telegram_remote_attachment_id?.length > 0}
                                <AuthImage
                                        width="100"
                                        imageClass="rounded-circle"
                                        src="/user/{contact.telegram_user_id}/contact/{contact.telegram_contact_id}/attachment/{contact.attachments[0]?.telegram_attachment_id ?? ''}/{contact.attachments[0]?.telegram_remote_attachment_id ?? '1'}"
                                />
                            {/if}
                        {/if}
                    </td>
                    <td>{contact.first_name ?? ''} {contact.last_name ?? ''}</td>
                    <td>{contact.telegram_contact_id ?? ''}</td>
                    <td class:ua={(contact.phone ?? '').indexOf('38')===0}>
                        {contact.phone ?? ''}
                    </td>
                    <td>{contact.username ?? ''}</td>
                    <td>
                        {#if contact.is_contact == true}
                            <i class="bi bi-check text-success"></i>
                        {:else }
                            <i class="bi bi-x text-danger"></i>
                        {/if}
                    </td>
                    <td>
                        {#if contact.is_mutual_contact == true}
                            <i class="bi bi-check text-success"></i>
                        {:else }
                            <i class="bi bi-x text-danger"></i>
                        {/if}
                    </td>
                    <td>{UserType[contact.type] ?? 'без типу'}</td>
                    <td>{UserStatus[contact.status] ?? 'без типу'}</td>
                    <td>{contact.was_online ? strToLocaleDateTime(contact.was_online) : ''}</td>
                    <td>{contact.created_at ? strToLocaleDateTime(contact.created_at): ''}</td>
                    <td><AddContactAsUserButton {contact}/></td>
                </tr>
            {/each}
        {:else}
            <tr>
                <td colSpan="1000" class="text-center">
                    <div class="alert alert-secondary">Немає контактів</div>
                </td>
            </tr>
        {/if}
    {:catch error}
        <tr>
            <td colSpan="1000" class="text-center">
                <div class="alert alert-danger">{error}</div>
            </td>
        </tr>
    {/await}
</tbody>
</table>
